import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInterceptor";
import "../styles/ScheduledClasses.css";
import SyncLoader from "../components/Loader";

const EditPaymentConfig = () => {
  const [amount, setAmount] = useState('');
  const [currency, setCurrency] = useState('');
  const [currentConfig, setCurrentConfig] = useState(null); // <-- Store original config
  const [isLoading, setIsLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const formatCurrencyAmount = (value, currencyCode) => {
    const numericValue = Number(value);
    const normalizedCode = (currencyCode || "").toUpperCase();

    if (!Number.isFinite(numericValue) || !normalizedCode) {
      return value;
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: normalizedCode,
      }).format(numericValue);
    } catch (error) {
      return `${normalizedCode} ${numericValue}`;
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get("admin/payment/amount/");
      setAmount(res.data.amount.toString());
      setCurrency(res.data.currency.toUpperCase());
      setCurrentConfig(res.data); // Save original for display
    } catch (err) {
      console.error("Failed to load config", err);
      alert("Failed to load payment config");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!amount || !currency) {
      alert("Amount and currency are required");
      return;
    }

    setSubmitting(true);
    try {
      await axiosInstance.post("admin/payment/amount/", {
        amount: parseFloat(amount),
        currency: currency.toUpperCase(),
      });
      alert("Payment config updated successfully");
      fetchConfig(); // Refresh displayed values
    } catch (err) {
      console.error("Update failed", err);
      alert("Failed to update payment config");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {isLoading && <SyncLoader />}
      <div className="scheduled-classes">
        <h2>Edit Payment Config</h2>

        {currentConfig && (
          <div style={{ marginBottom: "20px", backgroundColor: "#f9f9f9", padding: "15px", borderRadius: "8px" }}>
            <h4>Current Config</h4>
            <p><strong>Amount:</strong> {formatCurrencyAmount(currentConfig.amount, currentConfig.currency)}</p>
            <p><strong>Currency:</strong> {currentConfig.currency}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ maxWidth: "400px" }}>
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="amount" style={{ display: "block", marginBottom: "5px" }}>New Amount</label>
            <input
              type="number"
              id="amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="form-input"
              required
              min="0"
              step="0.01"
            />
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="currency" style={{ display: "block", marginBottom: "5px" }}>New Currency</label>
            <input
              type="text"
              id="currency"
              value={currency}
              onChange={(e) => setCurrency(e.target.value.toUpperCase())}
              className="form-input"
              required
              maxLength={3}
            />
          </div>

          <button type="submit" disabled={submitting}>
            {submitting ? "Saving..." : "Save Changes"}
          </button>
        </form>
      </div>
    </>
  );
};

export default EditPaymentConfig;

